<template>
  <div>
    <!-- <div class="bg"></div> -->
    <header>
      <h1 class="title">
        <a :href="home"><img :src="require('@/assets/img/logo.png')" alt="" /></a>
        <span>2022明基摄影后期大赛</span>
      </h1>
    </header>
    <img src="@/assets/img/upload/upload_bg.jpg" class="bg" alt="" />
    <!-- <upload-rule /> -->
    <div class="form-content">
      <h1>作品上传</h1>
      <el-form label-position="right" label-width="70px" :model="formData" :rules="rules" ref="uploadForm">
        <el-form-item label="作品名称" prop="worksname">
          <el-input v-model="formData.worksname" placeholder="仅限中英文，10个字以内"></el-input>
        </el-form-item>
        <el-form-item label="作品类别" prop="workstype">
          <el-select v-model="formData.workstype" placeholder="请选择" class="works-type">
            <el-option v-for="item in worksOPtions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="sync-works">
          <el-radio-group v-model="formData.attention">
            <el-radio :label="0">相机赛区</el-radio>
            <el-radio :label="1">手机赛区</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传文件" prop="workslist">
          <viewer :images="formData.workslist.map((i) => i.url)">
            <el-upload class="upload-content" accept="image/jpeg,image/jpg" action :http-request="handleUploadFn"
              :on-preview="handlePreview" :on-remove="handleRemoveFn" :file-list="
                formData.workslist.filter((i) => i.status === 'success')
              " :before-upload="beforeUploadFn" :on-error="handleErrorFn" :limit="1" list-type="picture">
              <el-button type="primary" class="button-inline">点击上传</el-button>
              <div slot="tip" class="upload-tip">
                JPG格式，1个作品类别仅1张图，3M≤尺寸≤10M
              </div>
            </el-upload>
          </viewer>
        </el-form-item>
        <el-form-item label="作品介绍" prop="worksIntroduce">
          <el-input type="textarea" v-model="formData.worksIntroduce" maxlength="100" show-word-limit resize="none"
            placeholder="100个字以内">
          </el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="author">
          <el-input v-model="formData.author" placeholder="限中文4个字以内，英文和空格12个以内"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone" type="number"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="formData.code" class="input-code" type="number"></el-input>
          <el-button size="small" type="primary" class="button-inline" @click="sendCodeEvent"
            :disabled="baseData.sec > 0">{{
                baseData.sec > 0 ? `${baseData.sec}秒后可重发` : "发送验证码"
            }}</el-button>
        </el-form-item>
        <!-- <el-form-item label="推荐单位(选填)" class="recommend-wrap">
          <el-cascader
            placeholder="请选择推荐单位"
            v-model="formData.recommend"
            :options="recommendOptions"
            :props="{ expandTrigger: 'hover' }"
            style="width: 100%"
          ></el-cascader>
        </el-form-item> -->
        <el-form-item>
          <el-checkbox v-model="formData.checked"></el-checkbox>
          <span class="protocol">我已阅读<i @click="dialogVisible = true">《投稿须知》</i>，并同意所有条款</span>
        </el-form-item>
        <el-form-item>
          <el-button id="upload-btn" type="primary" class="button-block" @click="formSubmitEvent">提交</el-button>
        </el-form-item>
      </el-form>
      <el-dialog class="upload-dialog" title="投稿须知" :visible.sync="dialogVisible" width="60vw" top="10vh">
        <div class="dialog-content">
          <p class="first">2022明基摄影后期大赛【投稿细则】及【版权说明】</p>
          <p>1、本次赛事共设两条赛道：相机赛道、手机赛道。</p>
          <p>2、手机赛道作品必须使用手机拍摄（手机型号不限），由手机拍摄并经过后期处理参与投稿。</p>
          <p>3、每个赛道4个作品类别，分别是：人像、风光、创意与商业、动物（22年特殊单元）。</p>
          <p>4、请选择相应的赛道及单元上传作品，每个单元仅限上传1张作品参赛，每位参赛者总投稿量不超过8张。</p>
          <p>5、热爱摄影的朋友均可免费参加，年龄、国籍、职业不限。</p>
          <p>6、作品不得有任何文字、边框等标记，标题、作品描述中不得透露作者姓名。</p>
          <p>7、作品仅限数码文件，风格不限，但不接受无摄影元素纯粹电脑合成、拼贴的作品。</p>
          <p>8、作品格式为JPG，作品大小3M-10M，投稿成功后会有短信通知。</p>
          <p>
            9、作品须为参赛者原创，获奖后需调取参赛作品原件或原始RAW文件审核。参赛者若不能证明获奖作品为原创且未按照约定时间内提供或因作者原因（包括但不限于作者提供的电子邮箱、手机号不准确）无法接到通知，主办方将取消作品参赛资格，责任由该作者承担。
          </p>
          <p>
            10、参赛者的照片，须拥有照片的著作权并获得参赛照片中所包含人物的肖像权使用许可和其他必要的许可。同时，须保证参赛照片不侵犯任何第三人的著作权、肖像权、名誉权、隐私权、商标权、商号权等其他合法权益，如给主办方造成任何损失，或损害主办方名誉的参赛者，还应赔偿主办方的全部损失。
          </p>
          <p>
            11、任何人发现本届摄影大赛照片有侵权嫌疑，请及时与主办方联系。主办方一经接到包括有关照片肖像权、著作权等相关投诉，或者发现投稿作品中包含违反前条规定的内容时，将立即删除相关照片并把相关投诉转送至上传人，由参赛者投稿的照片自行解决相关投诉并承担全部涉及费用。
          </p>
          <p>12、赛事为免费参与投稿，任何机构或公司未经许可，不得擅自使用本次赛事名义进行宣传收费。</p>
          <p>13、对于含有违反我国法律法规、含有色情或暴力、侵害他人权益、违背社会公序良俗、违反宗教禁忌的作品，主办方有权取消其参赛资格。</p>
          <p>14、参加本次投稿的作品及获奖作品，作者有著作权和署名权，主办方享有使用权，在注明作者的情况下，主办方有权将该作品用于展览、宣传、出版等商业用途。</p>
          <p>参赛者须仔细阅读以上条款，一经投稿，即视为同意并遵守以上各条规定，因参赛者个人违反上述条款而导致的法律责任全部由该参赛者本人承担，与主办方无关。</p>
        </div>
      </el-dialog>
      <!-- component -->
    </div>
    <!-- 上传提示弹窗 -->
    <upload-tip v-if="uploadTipVisible" @submit="submit" />
    <!-- 扫码关注公众号弹窗-->
    <scan v-if="scanVisible" @confirm="confirm" />
  </div>
</template>
<script>
import recommendData from "@/data/recommend";
import { uploadPic } from "@/utils/upload2";
import { MessageBox } from "element-ui";

import worksApi from "@/api/works";
// import UploadRule from "./UploadRule.vue";
import UploadTip from "./UploadTip.vue";
import Scan from "./Scan.vue";
import { mapGetters, mapState } from "vuex";
let timer;

export default {
  name: "UploadForm",
  components: {
    UploadTip,
    Scan,
  },
  data() {
    var validateAuthor = (rule, value, callback) => {
      if (/^\s+$/.test(value)) {
        callback(new Error("格式或长度错误"));
        return;
      }

      if (!/^[\u4e00-\u9fa5a-zA-Z\s]{1,16}$/.test(value)) {
        callback(new Error("格式或长度错误"));
        return;
      }

      let match = value.match(/[\u4e00-\u9fa5]/g);

      if (!(!match || (match && match.length < 5))) {
        callback(new Error("汉字字符超过4个"));
        return;
      }

      match = value.match(/[A-Za-z\s]/g);
      if (!(!match || (match && match.length < 13))) {
        callback(new Error("英文和空格字符超过12个"));
        return;
      }
      callback();
    };
    return {
      formData: {
        worksname: "", // 作品名称
        workstype: "人像", //作品类别
        attention: 0, // 特殊关注单元
        worksIntroduce: "", //作品介绍
        author: "", //姓名
        phone: "", //手机号
        code: "", //验证码
        recommend: [], //推荐单位
        checked: "", //我已阅读
        workslist: [],
      },
      rules: {
        worksname: [
          { required: true, message: "请输入作品名称", trigger: "blur" },
          {
            pattern: /^[\u4e00-\u9fa5a-zA-Z]{1,10}$/,
            message: "仅限中英文，10个字以内",
            trigger: "blur",
          },
        ],
        workstype: [
          { required: true, message: "请选择作品类别", trigger: "change" },
        ],
        workslist: [{ required: true, message: "请上传作品", trigger: "blur" }],
        worksIntroduce: [
          { required: true, message: "请输入作品介绍", trigger: "blur" },
          {
            pattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            message: "格式或长度错误",
            trigger: "blur",
          },
        ],
        author: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: validateAuthor, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入4位验证码", trigger: "blur" },
          {
            pattern: /^\d{4}$/,
            message: "请输入4位验证码",
            trigger: "blur",
          },
        ],
      },
      worksOPtions: [
        {
          value: "人像",
          label: "人像",
        },
        {
          value: "风光",
          label: "风光",
        },
        {
          value: "创意与商业",
          label: "创意与商业",
        },
        {
          value: "动物",
          label: "动物",
        },
      ],
      recommendOptions: recommendData,
      dialogVisible: false,

      baseData: {
        sec: 0,
        showViewer: "",
      },
      uploadTipVisible: false,
      scanVisible: false,
      isSuccess: true, // 是否已投票成功
      home: process.env.VUE_APP_HOME,
    };
  },
  computed: {},
  created() {
    // if (location.search.indexOf("scan=true") > 0) {
    //   this.scanVisible = true;
    // }
  },
  methods: {
    /**
     * 发送验证码
     */
    sendCodeEvent() {
      if (this.baseData.sec > 0) {
        return;
      }
      this.$refs.uploadForm.validateField("phone", (err) => {
        if (!err) {
          this.baseData.sec = 90;
          this.countdownFn();
          worksApi.sendSMSCode(this.formData.phone);
        }
      });
    },

    /**
     * 倒计时
     */
    countdownFn() {
      clearInterval(timer);
      timer = setInterval(() => {
        if (this.baseData.sec <= 0) {
          clearInterval(timer);
        } else {
          this.baseData.sec--;
        }
      }, 1000);
    },

    /**
     * 表单提交
     */
    async formSubmitEvent() {
      if (!this.formData.checked) {
        this.$message.error("请同意 《投稿须知》");
        return;
      }
      if (
        this.formData.workslist.filter((i) => i.status === "success").length ===
        0
      ) {
        this.$message.error("图片上传中或没有上传图片");
        return;
      }
      const vm = this;
      this.$refs.uploadForm.validate(async (valid) => {
        if (valid) {
          if (vm.isSuccess) {
            vm.uploadTipVisible = true;
          } else {
            vm.request();
          }
        } else {
          this.$message.error("请完成表单再提交");
          return false;
        }
      });
    },
    submit() {
      this.uploadTipVisible = false;
      this.request();
    },
    async request() {
      let dataParams = JSON.parse(JSON.stringify(this.formData));

      dataParams.workslist = dataParams.workslist
        .filter((i) => i.status === "success")
        .map((i) => {
          return { picId: 0, url: i.url, picType: i.picType };
        });
      dataParams.attention = dataParams.attention;
      let data = await worksApi.uploadWorks(dataParams);
      if (data.code === 200) {
        window.bilicm.mbase.send_data();
        this.isSuccess = true;
        this.$confirm(
          "报名成功！等待管理员审核。你可以关注微博@明基专业摄影显示器，及时了解大赛信息",
          "提示",
          {
            confirmButtonText: "关注微博",
            cancelButtonText: "关闭",
            type: "warning",
          }
        ).then(() => {
          window.open("https://www.weibo.com/p/1006066464054299");
        });

        this.formData = {
          worksname: "", // 作品名称
          workstype: "人像", //作品类别
          attention: 0,
          worksIntroduce: "", //作品介绍
          author: "", //姓名
          phone: "", //手机号
          code: "", //验证码
          recommend: [], //推荐单位
          checked: "", //我已阅读
          workslist: [],
        };
      } else {
        this.isSuccess = false;
      }
    },
    confirm() {
      this.scanVisible = false;
    },
    /**
     * 上传之前
     */
    beforeUploadFn(file) {
      function judgeType(filename) {
        var type = filename.toLowerCase().substr(filename.lastIndexOf("."));
        return type === ".jpg" || type === ".jpeg" || type === ".jpe";
      }
      function judgeSize(size) {
        //大于3M小于10M
        return size >= 1024 * 1024 * 3 && size <= 1024 * 1024 * 10;
      }
      if (!judgeType(file.name)) {
        this.$message.error(`${file.name} 类型不符合规范`);
        return false;
      }

      if (!judgeSize(file.size)) {
        this.$message.error(
          `${file.name} 大小为 ${(file.size / 1024 / 1024).toFixed(
            2
          )}MB,不符合规范`
        );
        return false;
      }
      return true;
    },
    handleErrorFn(err, file, filelist) { },
    /**
     * 自定义上传方法
     */
    handleUploadFn(option) {
      uploadPic(option.file).then(async (res) => {
        if (res) {
          try {
            await worksApi.judgeImg(`${res}?x-oss-process=image/resize,p_10`);
            option.onSuccess(res);
            // console.log("res: " + res);
            const vm = this;
            let img = new Image();
            img.src = res;
            img.onload = function () {
              vm.formData.workslist.push({
                name: option.file.name,
                url: res,
                status: "success",
                picType: img.width >= img.height ? 0 : 1,
              }); //上传成功之后把值添加到imglist中
            };
          } catch (error) {
            // console.log("图片编码校验失败", option.file);
            this.$message.error(
              `图片编码校验失败，请重新上传或微博联系工作人员`
            );
            option.onError("上传失败");
          }
        } else {
          this.$message.error(`图片上传失败`);
          option.onError("上传失败");
        }
      });
    },
    /**
     * 用户删除
     */
    handleRemoveFn(file, workslist) {
      // this.formData.workslist = workslist; //删除某张图片时重新对imglist赋值
      this.$set(this.formData, "workslist", workslist);
    },
    handlePreview(file) {
      this.baseData.showViewer = true;
    },
    closeViewerFn() {
      this.baseData.showViewer = false;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input--suffix .el-input__inner::placeholder {
  color: $color-text-placeholder;
}

::v-deep .el-form-item {
  margin-bottom: 20px;
}

::v-deep .el-upload-list--picture .el-upload-list__item-status-label {
  background: $color-primary;
}

::v-deep .el-textarea__inner {
  height: 120px;
}

::v-deep .el-input__count {
  line-height: 1;
  right: 15px;
  bottom: 10px;
  font-size: 12px;
  color: $color-text-placeholder;
}

::v-deep .el-checkbox__inner {
  border-color: $color-border-deep;
}

::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
  display: none;
}

::v-deep {
  .el-upload-list__item {
    transition: none !important;
  }
}

.content-main {
  width: 1614px;
  margin: 0 auto;
}

.bg {
  display: block;
  margin: 0 auto;
  width: 100%;
}

header {
  height: 60px;
  margin: 0 auto;
  background: $color-bg-black;

  >h1 {
    padding: 0 90px;
    height: 100%;
    display: flex;
    align-items: center;

    img {
      display: block;
      width: 90px;
      height: 25px;
      cursor: pointer;
    }

    span {
      color: #fff;
      width: calc(100% - 90px);
      text-align: right;
      font-size: 24px;
      font-family: fangzhengzhengzhongheiti;
    }
  }
}

.form-content {
  width: 470px;
  margin: 0 auto;
  padding-bottom: 80px;
  padding-top: 40px;

  h1 {
    margin-bottom: 52px;
    font-size: 36px;
    color: $color-text-primary;
    font-weight: bold;
    text-align: center;
  }
}

.works-type {
  width: 180px;
}

.button-inline {
  width: 150px;
  height: 40px;
}

.button-block {
  width: 100%;
}

.upload-content {
  ::v-deep img {
    object-fit: cover;
  }
}

.upload-tip {
  margin-top: 8px;
  line-height: 14px;
  font-size: 14px;
  color: $color-text-placeholder;
  height: 14px;
}

.upload-dialog {
  .dialog-content {
    width: 50vw;
    margin: 0 auto;

    p {
      font-size: 14px;
      margin: 20px auto;

    }

    .first {
      color: #444444;
      font-size: 24px;
       margin-bottom: 50px;
       text-align: center;
    }
  }
}

.input-code {
  width: 180px;
  margin-right: 20px;
}

.recommend-wrap {
  ::v-deep .el-form-item__label {
    text-align: left;
    line-height: normal;
  }

  ::v-deep .el-form-item__content {
    width: 180px;
  }
}

.protocol {
  vertical-align: -1px;
  color: $color-text-regular;
  margin-left: 10px;

  >i {
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      color: $color-primary;
    }
  }
}

.dialog-iframe {
  width: 100%;
  height: 70vh;
}

.sync-works {
  ::v-deep .el-form-item__content {
    line-height: 0;

    span {
      font-size: 12px;
    }

    .phone-camera {
      margin-bottom: 10px;
    }
  }
}
</style>